import { useRefreshEmailData } from '@/hooks/useEmailQueries';
import {
  Button,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui';
import { RefreshCw, Search } from 'lucide-react';

interface IProps {
  searchTerm: string,
  statusFilter: string,
  setSearchTerm: (value: string) => void,
  setStatusFilter: (value: string) => void
}

export const Controls = ({ searchTerm, setSearchTerm, statusFilter, setStatusFilter }: IProps) => {
  const { mutate: refreshData, isPending: refreshing } = useRefreshEmailData();

  const options = [
    { value: 'all', label: 'All Statuses' },
    { value: 'sent', label: 'Sent' },
    { value: 'failed', label: 'Failed' },
  ]

  return (
    <div className="flex flex-col sm:flex-row gap-4 items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search emails..."
            className="pl-10 w-64"
            value={searchTerm}
          />
        </div>

        <Select value={statusFilter} onValueChange={setStatusFilter}>
          <SelectTrigger className="w-40">
            <SelectValue placeholder="Filter by status" />
          </SelectTrigger>
          <SelectContent>
            {options.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <Button
        className="flex items-center gap-2"
        onClick={() => refreshData()}
        disabled={refreshing}
        variant="outline"
        >
        <RefreshCw className={`h-4 w-4 ${refreshing ? 'animate-spin' : ''}`} />
        Refresh
      </Button>
    </div>
  )
}